'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var Typography = require('../Typography/Typography.js');
var TableCell = require('./TableCell.js');
var classNames = require('classnames');
var makeStyles = require('../../Styles/makeStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var useStyles = makeStyles["default"]({
  tableHeaderCell: {
    padding: '16px 8px'
  },
  allBorders: {
    border: '1px solid #e0e0e0'
  },
  noBorders: {
    borderStyle: 'hidden'
  },
  verticalBorders: {
    borderStyle: 'solid',
    borderLeftWidth: '1px',
    borderTopStyle: 'hidden',
    borderBottomStyle: 'hidden',
    borderRightWidth: '1px',
    borderColor: '#e0e0e0'
  },
  horizontalBorders: {
    borderStyle: 'solid',
    borderLeftStyle: 'hidden',
    borderTopWidth: '1px',
    borderBottomWidth: '1px',
    borderRightStyle: 'hidden',
    borderColor: '#e0e0e0'
  },
  exterior: {
    border: '0px solid #e0e0e0'
  },
  onlyRightBorder: {
    borderStyle: 'solid',
    borderRightWidth: '1px',
    borderTopStyle: 'hidden',
    borderBottomStyle: 'hidden',
    borderLeftStyle: 'hidden',
    borderColor: '#e0e0e0'
  },
  rightTopBorders: {
    borderStyle: 'solid',
    borderRightWidth: '1px',
    borderTopWidth: '1px',
    borderBottomStyle: 'hidden',
    borderLeftStyle: 'hidden',
    borderColor: '#e0e0e0'
  }
});

var TableHeaderCell = function TableHeaderCell(_ref) {
  var className = _ref.className,
      padding = _ref.padding,
      children = _ref.children,
      borders = _ref.borders,
      stickyColumn = _ref.stickyColumn,
      props = objectWithoutProperties(_ref, ["className", "padding", "children", "borders", "stickyColumn"]);

  var styles = useStyles();
  var appliedBorders = null;

  switch (borders) {
    case 'all':
      appliedBorders = stickyColumn ? styles.onlyRightBorder : styles.allBorders;
      break;

    case 'interior':
      appliedBorders = stickyColumn ? styles.onlyRightBorder : styles.allBorders;
      break;

    case 'exterior':
      appliedBorders = styles.exterior;
      break;

    case 'none':
      appliedBorders = styles.noBorders;
      break;

    case 'noOuterVertical':
      appliedBorders = stickyColumn ? styles.onlyRightBorder : styles.allBorders;
      break;

    case 'noOuterHorizontal':
      appliedBorders = stickyColumn ? styles.onlyRightBorder : styles.allBorders;
      break;

    case 'onlyVertical':
      appliedBorders = stickyColumn ? styles.onlyRightBorder : styles.verticalBorders;
      break;

    case 'onlyHorizontal':
      appliedBorders = stickyColumn ? styles.exterior : styles.horizontalBorders;
      break;

    case 'onlyInteriorVertical':
      appliedBorders = stickyColumn ? styles.onlyRightBorder : styles.verticalBorders;
      break;

    case 'onlyInteriorHorizontal':
      appliedBorders = stickyColumn ? styles.exterior : styles.horizontalBorders;
      break;

    case 'onlyOuterRight':
      appliedBorders = styles.exterior;
      break;

    case 'onlyOuterLeft':
      appliedBorders = styles.exterior;
      break;

    case 'onlyOuterTop':
      appliedBorders = styles.exterior;
      break;

    case 'onlyOuterBottom':
      appliedBorders = styles.exterior;
      break;
  }

  var appliedClass = classNames__default["default"](defineProperty({}, styles.tableHeaderCell, !padding), defineProperty({}, appliedBorders, !!borders), className);
  return React__default["default"].createElement(TableCell, _objectSpread({
    className: appliedClass,
    padding: padding
  }, props), React__default["default"].createElement(Typography, {
    variant: "subtitle2",
    color: 'textSecondary'
  }, children));
};

module.exports = TableHeaderCell;
